import { AgentChatProvider } from "./AgentChatProvider";
import AgentChatUI from "./AgentChatUI";

export default function AgentChat({ apiBasePath, ...uiProps }) {
  return (
    <AgentChatProvider apiBasePath={apiBasePath}>
      <AgentChatUI {...uiProps} />
    </AgentChatProvider>
  );
}
